import React from 'react';
import { ExitScanModeViewStore } from 'modules/order/stores';
import { ExitScanModeTemplate } from 'themes/modules/order/pages';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new ExitScanModeViewStore(rootStore, componentProps), 'exitScanModeViewStore')
class ExitScanMode extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <ExitScanModeTemplate {...this.props} />;
	}
}

export default ExitScanMode;
